<template>
  <div class="mt-8">
    <v-layout wrap>
      <v-flex>
        <!-- Snackbar -->
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>
          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <!-- Dialog Freeze -->
        <v-dialog v-model="dialog.freeze"
          @keydown.esc="dialog.freeze = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Freeze Kolom
              <v-spacer/>
              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>
              <v-icon 
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>
            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                      </div>
                      <v-list-item-group multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in configHeaders" 
                            :key="index"
                            class="px-0"
                            @click="item.freeze = !item.freeze ? true : false">
                            <v-list-item-action class="mr-4">
                              <v-checkbox color="#718EBF" :input-value="item.freeze"></v-checkbox>
                            </v-list-item-action>
                            <v-list-item-content>
                              <div :class="item.freeze ? 'font-weight-bold' : ''" :style="item.freeze ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-divider class="mb-3 mt-0" style="border-top: 2px dashed #EBEBEB;"/>
            <v-card-actions class="mb-2">
              <v-spacer/>
              <v-btn elevation="0" color="#718EBF" style="border-radius: 10px;" class="body-2 font-weight-bold text-capitalize white--text" @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Freeze
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Dialog Hide -->
        <v-dialog v-model="dialog.hide"
          @keydown.esc="dialog.hide = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Hide Kolom
              <v-spacer/>
              <v-icon @click="dialog.fullscreen = !dialog.fullscreen ? true : false" class="cursor-pointer mr-1" size="24" color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>
              <v-icon @click="dialog.hide = false; dialog.fullscreen = false;" class="cursor-pointer" size="24" color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            <v-divider class="mt-3 mb-2" style="border-top: 2px dashed #EBEBEB;"/>
            <v-card-text class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                      </div>
                      <v-list-item-group multiple>
                        <v-list flat>
                          <v-list-item v-for="(item, index) in headers" :key="index" class="px-0" @click="item.hide = !item.hide ? true : false">
                            <v-list-item-action class="mr-4">
                              <v-checkbox color="#718EBF" :input-value="item.hide"></v-checkbox>
                            </v-list-item-action>
                            <v-list-item-content>
                              <div :class="item.hide ? 'font-weight-bold' : ''" :style="item.hide ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-divider class="mb-3 mt-0" style="border-top: 2px dashed #EBEBEB;"/>
            <v-card-actions class="mb-2">
              <v-spacer/>
              <v-btn elevation="0" color="#718EBF" style="border-radius: 10px;" class="body-2 font-weight-bold text-capitalize white--text" @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Hide
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Dialog Filter -->
        <v-dialog v-model="dialog.filter"
          @keydown.esc="dialog.filter = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title class="d-flex align-center pa-4 text-right popup-header">
              <div class="title font-weight-bold">Filter Data</div>
              <v-spacer/>
              <v-icon @click="dialog.fullscreen = !dialog.fullscreen ? true : false" class="cursor-pointer mr-1" size="24" color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>
              <v-icon @click="dialog.filter = false; dialog.fullscreen = false;" class="cursor-pointer" size="24" color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            <v-divider class="mb-2" style="border-top: 2px dashed #e0e0e0;"/>
            <v-card-text class="py-0 my-4">
              <v-select
                filled
                rounded
                dense
                color="#718EBF"
                placeholder="Contoh. 2023"
                hide-details
                :items="years"
                :item-color="set_color"
                v-model="filter.year"
                style="border-radius: 10px;">
              </v-select>
            </v-card-text>
            <v-divider class="mt-2" style="border-top: 2px dashed #e0e0e0;"/>
            <v-card-actions class="pa-4">
              <v-spacer/>
              <v-btn @click="dialog.filter = false; fetch();" width="120" elevation="0" color="green" rounded class="body-2 font-weight-bold text-capitalize white--text">
                Filter
              </v-btn>
              <v-btn @click="dialog.filter = false" width="120" outlined elevation="0" color="red" rounded class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Section dan Table -->
        <section>
          <v-card flat class="ma-4 mt-0 box-shadow pb-5" style="border-radius: 10px;">
            <v-row class="pa-4 py-0">
              <v-col cols="12" md="7">
                <span class="fs-16 black--text ml-2" style="font-weight: 600;">
                  Detail Stok
                </span>
              </v-col>
              <v-col cols="12" md="12" class="d-flex align-center">
                <!-- <v-autocomplete
                  v-on:change="fetch()"
                  filled
                  rounded
                  dense
                  solo
                  color="#718EBF"
                  placeholder="Nama Cabang"
                  hide-details
                  :items="cabang"
                  item-value="name"
                  item-text="name"
                  :item-color="set_color"
                  class="mr-4"
                  clearable
                  v-on:clear="branch_name = ''; fetch()"
                  v-model="branch_name"
                  style="border-radius: 10px;">
                </v-autocomplete> -->
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  :close-on-click-outside="true"
                  @keydown.esc="closeDatePicker"
                  @click:outside="closeDatePicker"
                  class="ml-3"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="formattedDate"
                      :color="set_color"
                      placeholder="dd/mm/yyyy"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      filled
                      rounded
                      dense
                      single-line
                      hide-details
                      clearable
                      @click:clear="clearDate"
                      @click="openDatePicker"
                      @keydown.enter="openDatePicker"
                      class="fs-12 little-placeholder"
                      style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 250px"
                    >
                      <template v-slot:append>
                        <v-icon :color="set_color" @click="openDatePicker" class="cursor-pointer">mdi-calendar</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="inputdatime"
                    :color="set_color"
                    @input="onDateChange"
                    locale="id"
                    :max="new Date().toISOString().substr(0, 10)"
                    :allowed-dates="allowedDates"
                    @click:date="onDateChange"
                  />
                </v-menu>
                <v-text-field
                  @click:clear="search = ''; fetch();"
                  v-on:keyup.enter="fetch()"
                  filled
                  rounded
                  dense
                  single-line
                  hide-details
                  :color="set_color"
                  placeholder="Cari data yang Anda butuhkan . . ."
                  append-icon="mdi-magnify"
                  clearable
                  v-model="search"
                  class="ml-3 fs-12 little-placeholder"
                  style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 320px">
                </v-text-field>
              </v-col>
            </v-row>
            <v-card flat class="mt-0 mx-5" style="border-radius: 2px; border: 1px solid #E7E7E7;">
              <div class="view">
                <div v-if="!process.load" :class="process.load || list.length === 0 ? '' : 'wrapper'">
                  <table style="border-radius: 10px; width: 100%;" class="table-grid table">
                    <tr>
                      <th v-for="header in configHeaders" :key="header.value" :style="`font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; min-width: ${header.width};`">
                        {{ header.text }}
                      </th>
                    </tr>
                    <tr v-for="(item, index) in list" :key="index" @click="selected.row = index" :class="selected.row === index ? 'selected' : ''">
                      <td v-for="header in configHeaders" :key="header.value" :style="`font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; white-space: nowrap; text-align: left;`">
                        <span v-if="header.format">{{ rowFormat(header.format, item[header.value]) }}</span>
                        <span v-else>{{ item[header.value] }}</span>
                      </td>
                    </tr>
                  </table>
                </div>
                <v-card-text v-if="process.load" class="pb-0 my-4" style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-4 title">Mohon Tunggu . . .</div>
                    <v-progress-linear :color="set_color" indeterminate rounded height="10"></v-progress-linear>
                  </div>
                </v-card-text>
                <v-card-text v-if="list.length === 0 && !process.load" class="pb-0 my-4" style="height: calc( 100vh - 350px ); display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <v-img class="mx-auto" contain alt="vuetify" :width="90" :height="90" :src="require('@/assets/image/empty.png')"></v-img>
                    <div class="mt-3 fs-16">Belum Ada Data</div>
                  </div>
                </v-card-text>
                <pagination v-if="!process.load && pagination.total_data > 0"
                  @changePage="fetch($event)" 
                  @reloadPage="fetch($event)" 
                  :model="pagination" :display="paginationList"/>
              </div>
            </v-card>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>


<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
  data () {
      return {
        checkbox: false,

        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          filter: false,

          form: false,
          delete: false
        },

        cabang: [],
        branch_name: '',
        
        search: '',

        inputdatime: '', // Tidak ada default tanggal
        menu: false,

        filter: {
          year: new Date().getFullYear()
        },

        selected: {
          freeze: [],
          delete: [],
          row: []
        },

        sales: [],

        form: {
          id: '',
          sales_id: '',
          name_alias: '',
          name: '',
          mobilephone: '',
          address: '',
          pic_name: '',
          email: '',
          nik: '',
          npwp: '',
          plafon: '',
          faktur: '',
          term: '',
          ttd: ''
        },

        options: {},
        headers: [],
        list: [],
        pagination: {},
        paginationList: {
          page: 1,
          row: 50
        },

        lastIndex: 0,
        limit: 50,

        process: {
          load: false,

          delete: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination_other.vue')
    },
    watch: {
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          
          this.fetch(pagination)
        },
        deep: true
      },
      'inputdatime': {
        handler (newVal, oldVal) {
          if (newVal !== oldVal) {
            // Tanggal berubah, tutup menu
            this.menu = false
            // Fetch data jika ada tanggal
            if (newVal) {
              this.$nextTick(() => {
                this.fetch()
              })
            }
          }
        }
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      user () {
        return this.$store.state.user
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },

      years () {
        let max = new Date().getFullYear()+2, min = max - 2, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      },

      // Format tanggal untuk ditampilkan
      formattedDate () {
        if (!this.inputdatime) return ''
        // inputdatime: 'YYYY-MM-DD'
        const [year, month, day] = this.inputdatime.split('-')
        return `${day}/${month}/${year}`
      }
    },
    mounted () {
      this.fetchCabang()
      this.inputdatime = '' // Tidak ada default tanggal
      this.menu = false
      this.$nextTick(() => { this.fetch() })
    },
    methods: {
      // Method untuk menangani perubahan tanggal
      onDateChange() { 
        this.menu = false; 
      },

      // Method untuk clear tanggal
      clearDate() { this.inputdatime = ''; this.menu = false; this.$nextTick(() => { this.fetch() }) },

      // Method untuk membuka menu date picker
      openDatePicker() { this.menu = true },

      // Method untuk menutup menu date picker
      closeDatePicker() { this.menu = false },

      // Method untuk menentukan tanggal yang diizinkan
      allowedDates(val) {
        const today = new Date()
        const selectedDate = new Date(val)
        return selectedDate <= today
      },

      async fetchCabang() {

         let params = {
          limit: 10000000000000
        }

        await get(`admin/branch/data`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.cabang = res.results.data
          }
        })
      },
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          data = value*1
        } else if (format === 'number_thousand') {
          data = value ? Number(value).toLocaleString('id-ID') : '0'
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = Number(value) + ' %'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        }  else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },

      async fetch (pagination = { row: 50, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row
        this.paginationList = pagination

        // Format tanggal untuk API (yyyy-mm-dd)
        let formattedDate = ''
        console.log(this.inputdatime)
        if (this.inputdatime) {
          try {
            const date = new Date(this.inputdatime)
            if (!isNaN(date.getTime())) {
              formattedDate = this.inputdatime
            }
          } catch (error) {
            formattedDate = ''
          }

          console.log(formattedDate)
          console.log(this.inputdatime)
        }

        let params = {
          varian_id: this.$route.params.id,
          branch_id: this.$route.query.gudang,
          limit: pagination.row,
          page: pagination.page,
          sort: '-input_datetime',
          // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search,
          input_datetime: formattedDate,
          // unit_id: this.$store.state.user.unit_id === '0' || this.$store.state.user.unit_id === 0 ? '' : this.$store.state.user.unit_id
        }

        this.selected.row = []

        // admin/services/data
        
        await get(`admin/item_stock/data_log`, { params })
        .then(response => {
          let res = response.data
          
          this.process.load = false
          
          this.list = []
          this.pagination = {}
          
          if (res.status === 200) {
            this.headers = [
              {
                text: 'No',
                width: '80',
                value: 'index',
                freeze: true,
                hide: false
              },
              {
                text: 'Nama Varian',
                width: '200px',
                value: 'varian_name',
                freeze: true,
                hide: false
              },
              {
                text: 'Terakhir Update',
                width: '180px',
                value: 'input_datetime',
                freeze: false,
                hide: false,
                format: 'datetime'
              },
              {
                text: 'Qty Masuk',
                width: '150px',
                value: 'in_qty',
                freeze: false,
                hide: false,
                format: 'number_thousand'
              },
              {
                text: 'Qty in Extra',
                width: '180px',
                value: 'in_qty_extra',
                freeze: false,
                hide: false,
                format: 'number_thousand'
              },
              {
                text: 'Qty Keluar',
                width: '180px',
                value: 'out_qty',
                freeze: false,
                hide: false,
                format: 'number_thousand'
              },
              {
                text: 'Gudang',
                width: '150px',
                value: 'branch_name',
                freeze: false,
                hide: false,
              },
              {
                text: 'Referensi',
                width: '150px',
                value: 'ref',
                freeze: false,
                hide: false,
              },
              {
                text: 'Admin',
                width: '150px',
                value: 'input_user_name',
                freeze: false,
                hide: false,
              }
            
            ]
    
            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1

            this.list = res.results.data.map((item, idx) => ({
              ...item,
              index: this.lastIndex + idx
            }));
            // console.log(this.list)
            this.pagination = res.results.pagination

            // this.list.map(obj => {
            //   obj.is_active = obj.is_active === 'Aktif' ? true : false
            // })

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1


            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },


      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: index !== undefined ? this.list[index].id : '',
          name: index !== undefined ? this.list[index].name : '',
          address: index !== undefined ? this.list[index].address : '',
          mobilephone: index !== undefined ? this.list[index].mobilephone : "",
          pic_name: index !== undefined ? this.list[index].pic_name : "",
          email: index !== undefined ? this.list[index].email : "",
          nik: index !== undefined ? this.list[index].nik : "",
          npwp: index !== undefined ? this.list[index].npwp : "",
          // is_active: index !== undefined ? this.list[index].is_active === 'Aktif'? 1 : 0 : 1
        }

        this.process.form = false

        this.message.error = ''
      },

      updateStatus (item) {
        this.selected.row = [item]

        this.dialog.form = true
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.form.id === '' ? 'admin/customer/add' : 'admin/customer/update'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.reset()
              
              if (this.form.id === '') {
                this.fetch()
              } else {
                this.fetch(this.paginationList)
              }
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`admin/customer/delete`, {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch(this.paginationList)
          } else {
            this.message.error = res.message
          }
        })
      }

    }
  }
</script>

<style>
  /* ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #F5F5F5;
  }
  ::-webkit-scrollbar-track{
    background-color: #F5F5F5;
    border-radius: 10px;
  } */
  ::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: #718EBF;
  }
  table, th, td {
    /* border: 1px solid #ededed;
    border-collapse: collapse; */
    /* border: thin ridge black; */
    border-spacing: 4px;
    border-collapse: collapse;
  }

  .view {
    margin: auto;
    /* width: 100%; */
  }

  .wrapper { 
    overflow-y: auto; 
    height: calc(100vh - 310px); 
  } 

  .wrapper-none { 
    /* overflow-y: auto; 
    height: calc(100vh - 270px);  */
  } 

  .wrapper th { 
    position: sticky; 
    top: 0; 
    background-color: white !important;
  } 
  .sticky-col {
    position: -webkit-sticky;
    position: sticky;
    background-color: white !important;
  }

  .one-col {
    width: 60px;
    min-width: 60px;
    max-width: 60px;
    left: 0px;
  }

  .second-col {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    left: 150px;
  }

  .three-col {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    left: 300px;
  }

  .four-col {
    width: 200px;
    min-width: 200px;
    max-width: 200px;
    left: 450px;
  }

  tr:hover {background-color: #1976d236;}
  tr.selected {background-color: #1976d236;}
</style>
  
  